import React, { useEffect, useCallback, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Box from "@material-ui/core/Box";
import "@fontsource/montserrat";
import {
  COHORT_USER_SEND_REQUEST,
  SEND_REQUEST_TO_MENTOR,
} from "../common/constants/ApplicationUrl";
import axios from "axios";
import { isLoading } from "../common/dependencies/action/action";
import api from "../common/dependencies/utils/Api";

import { connect } from "react-redux";
// import { styled } from "@material-ui/styles";
import swal from "sweetalert";
import { InputBase } from "@material-ui/core";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#e8c7ff",
    // backgroundColor: '#efefef',
    padding: "10px",
    maxWidth: "none",
  },
  tooltipArrow: {
    backgroundColor: "#e8c7ff",
    // backgroundColor: '#efefef',
  },
  upperHeading: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "35px",
    width: "400px",
    backgroundColor: "rgb(58, 194, 215)",
    padding: "0 20px",
    borderRadius: "10px",
  },
  textField: {
    height: "200px",
    // width: '300px',
    marginTop: "10px",
    border: 0,
  },
  whiteInput: {
    backgroundColor: "#fff",
    height: "250px",
    width: "400px",
    border: "1px solid black",
  },
  noBorder: {
    border: "none",
    outline: "none",
  },
  button: {
    marginTop: "20px",
    fontFamily: "Montserrat",
    fontWeight: 600,
    fontSize: "16px",
    borderRadius: "30px",
    backgroundColor: "#816ab0",
    color: "#fff",
    transition: "0.5s",
    "&:hover": {
      transform: "translateY(-10px)",
      backgroundColor: "#816ab0",
    },
  },
}));

const Input = (props) => {
  const { setData, setDidDataRender, data, didDataRender } = props;

  useEffect(() => {
    if (didDataRender === 0) {
      setData(localStorage.getItem("CohortCohortMentorRequestData"));
      setDidDataRender(1);
    }
  }, []);

  return props.isPurpose ? (
    <Typography
      style={{
        backgroundColor: "#fff",
        marginTop: "10px",
        borderRadius: "8px",
        padding: "10px",
        fontFamily: "Montserrat",
        height: "250px",
        color: "rgba(0,0,0,0.8)",
        overflowY: "scroll",
        width: "400px",
      }}
    >
      {props.purpose}
    </Typography>
  ) : (
    <InputBase
      placeholder="Please type Intent to be part of this Cohort in 100 words"
      onChange={(e) => {
        const value = e.target.value;
        const newData = value.replace(/(^\s*)|(\s*$)/gi, "");
        const newerData = newData.replace(/[ ]{2,}/gi, " ");
        if (newerData.split(" ").length <= 100) {
          setData(e.target.value);
        }
      }}
      value={data}
      rows={11}
      maxRows={11}
      multiline
      fullWidth
      style={{
        backgroundColor: "#fff",
        marginTop: "10px",
        borderRadius: "8px",
        padding: "10px",
        fontFamily: "Montserrat",
        height: "250px",
      }}
    />
  );
};

function ArrowTooltips(props) {
  const classes = useStyles();
  const [data, setData] = React.useState("");
  const [didDataRender, setDidDataRender] = useState(0);
  const handleClick = () => {
    localStorage.setItem("CohortMentorRequestData", data);
    if (!data) {
      return;
    }
    let value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

    // if (!value) {
    //   return;
    // }
    // if (value?.role !== "Mentor") {
    //   swal("Unauthorized", "You need to be a mentor to apply", "info");
    //   return;
    // }
    props.openLoader();
    //  axios({
    //   url: COHORT_USER_SEND_REQUEST,
    //   method: 'post',
    //   data: {
    //     mentorId: value?.id,
    //     cohortId: props.cohortData?.cohortId,
    //     intentToMentor: data
    //   }
    //  })
    api
      .POST(COHORT_USER_SEND_REQUEST, {
        // mentorId: value?.id,
        cohortId: props?.cohortData?.cohortId,
        intentToMentor: data,
        cohortType:props?.cohortData?.cohortVisibility ? "public" : "private",
      })
      .then((res) => {
        props.closeLoader();
        if(res?.data?.success)
        {
          swal("Success", "Your Request Sent Successfully!", "success");
          props?.change("Applied");
        }
      else
      {
        swal("Info", "Server error, please try again after some time.", "info");

      }
      })
      .catch((err) => {
        props.closeLoader();
      });
  };

  return (
    <Tooltip
      classes={{
        tooltip: classes.root,
        tooltipArrow: classes.tooltipArrow,
      }}
      title={
        <Box>
          <Box className={classes.upperHeading}>
            INTENT TO BE PART OF COHORT
          </Box>
          <Input
            data={data}
            setData={setData}
            purpose={props.purpose}
            isPurpose={props.isPurpose}
            didDataRender={didDataRender}
            setDidDataRender={setDidDataRender}
          />
          <Typography
            style={{
              textAlign: "right",
              fontFamily: "Montserrat",
              fontSize: "14px",
              marginTop: "10px",
              fontWeight: "bold",
              paddingRight: "5px",
            }}
          >
            Word Count:{" "}
            {data?.length === 0
              ? 0
              : data
                  ?.replace(/(^\s*)|(\s*$)/gi, "")
                  ?.replace(/[ ]{2,}/gi, " ")
                  ?.split(" ")?.length}{" "}
            / 100
          </Typography>
          <Box
            sx={{ width: "400px", display: "flex", justifyContent: "center" }}
          >
            <div className="newuserTooltip top-btn">
              <Button
                onClick={handleClick}
                variant="contained"
                className={classes.button}
              >
                Apply Now
              </Button>
              <span
                className="tooltiptext tooltip-bottom"
                style={{ left: "63px", top: "57px", width: "130px" }}
              >
                Click to Apply
              </span>
            </div>
          </Box>
        </Box>
      }
      arrow
      placement="right"
      interactive
    >
      {props.children}
    </Tooltip>
  );
}

const mapDispatchToProps = (dispatch) => ({
  openLoader: () => dispatch(isLoading(true)),
  closeLoader: () => dispatch(isLoading(false)),
});

export default connect(null, mapDispatchToProps)(ArrowTooltips);
